import { useState } from "react";
import { useLicenseDetails } from "../../contexts/licenseDetails";
import LicenseService from "../../services/LicensesService";
import Button from "../Button/Button";
import Input from "../Input/Input";
import {
   getZodFieldErrors,
   licenseDueDateSchema,
} from "../../validations/license-subpages.schema";

export function LicenseUpdateDueDatePage({ license }) {
   const { setCurrentSubTab, setLicense } = useLicenseDetails();
   const [dueDate, setDueDate] = useState(
      license?.currentBilling?.dueDate?.slice(0, 10) ?? ""
   );
   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);

   async function handleSubmit(event) {
      event.preventDefault();
      const billingId = license?.currentBilling?.id;
      const validation = licenseDueDateSchema.safeParse({
         billingId: billingId == null ? "" : String(billingId),
         dueDate,
      });
      if (!validation.success) {
         setErrors(getZodFieldErrors(validation.error));
         return;
      }
      setErrors({});

      setIsSubmitting(true);
      try {
         const response = await LicenseService.updateDueDate(
            billingId,
            license.id,
            dueDate
         );
         if (response?.status >= 200 && response.status < 300) {
            const refreshedLicense = await LicenseService.getLicense(license.id);
            if (refreshedLicense?.status >= 200 && refreshedLicense.status < 300) {
               setLicense(refreshedLicense.data);
            } else {
               setLicense({
                  ...license,
                  currentBilling: {
                     ...license.currentBilling,
                     dueDate,
                  },
               });
            }
            setCurrentSubTab(null);
         }
      } finally {
         setIsSubmitting(false);
      }
   }

   return (
      <div className="fade-in mt-0.5!">
         <div className="flex flex-row items-center justify-between">
            <h2 className="font-bold! text-[15px]!">Alterar vencimento</h2>
         </div>
         <p className="mt-3! opacity-60 leading-snug!">
            Altere a data de vencimento da cobrança atual da licença.
         </p>
         {errors.billingId && (
            <span className="error-message mt-3!">{errors.billingId}</span>
         )}
         <form className="flex flex-col gap-3 mt-7!" onSubmit={handleSubmit}>
            <Input
               type="date"
               name="dueDate"
               id="dueDate"
               labelText="Data de vencimento *"
               value={dueDate}
               onChange={({ target }) => setDueDate(target.value)}
               disabled={isSubmitting}
               error={errors.dueDate}
            />
            <div className="w-full flex flex-row items-center justify-end gap-3! mt-6!">
               <Button
                  className="button-white"
                  label="Cancelar"
                  onClick={() => setCurrentSubTab(null)}
                  disabled={isSubmitting}
               />
               <Button
                  className="button-blue"
                  label="Salvar"
                  type="submit"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
               />
            </div>
         </form>
      </div>
   );
}